import React from 'react';
import { Box, Typography } from '@mui/material';
import { Loader } from './index';
import { useLoading } from 'src/store/loadingContext';

export const GlobalLoadingOverlay: React.FC = () => {
  const { isLoading, message, subtitle } = useLoading();

  if (!isLoading) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        backdropFilter: 'blur(4px)',
      }}
    >
      <Loader />
      <Typography 
        variant="h6" 
        color="white" 
        sx={{ 
          fontWeight: 500,
          textAlign: 'center',
          maxWidth: 400,
          px: 2
        }}
      >
        {message}
      </Typography>
      <Typography 
        variant="body2" 
        color="rgba(255, 255, 255, 0.7)" 
        sx={{ 
          textAlign: 'center',
          maxWidth: 300,
          px: 2
        }}
      >
        {subtitle}
      </Typography>
    </Box>
  );
};
